export enum TASK_TYPE {

    USER_FollowUpAR = '00000850-1000-0000-0000-000000000001',
    USER_FollowUpPatient = '00000850-1000-0000-0000-000000000002',
    USER_ReviewPatientRecord = '00000850-1000-0000-0000-000000000003',
    USER_MessageToGroup = '00000850-1000-0000-0000-000000000004',
    USER_MessageToUser = '00000850-1000-0000-0000-000000000005',
    USER_MessageSelf = '00000850-1000-0000-0000-000000000006',
    USER_Recall = '00000850-1000-0000-0000-000000000007',
    USER_ReviewReport = '00000850-1000-0000-0000-000000000008',
    USER_FollowUpAR_Insurance = '00000850-1000-0000-0000-000000000009',
    USER_FollowUpSchedule = '00000850-1000-0000-0000-000000000010',
    USER_ReferralReceived = '00000850-1000-0000-0000-000000000011',
    USER_FollowupPatientDueToCancelation = '00000850-1000-0000-0000-000000000012',
    USER_FollowUpCase = '00000850-1000-0000-0000-000000000013',
    USER_FollowUpProcedure = '00000850-1000-0000-0000-000000000014',
    USER_FollowupPatientDueToRescheduleRequest = '00000850-1000-0000-0000-000000000015',
}

export enum TASK_STATUS {
    NotStarted = '00000051-1000-0000-0000-000000000001',
    Progress = '00000051-1000-0000-0000-000000000002',
    Waiting = '00000051-1000-0000-0000-000000000003',
    Deferred = '00000051-1000-0000-0000-000000000004',
    Completed = '00000051-1000-0000-0000-000000000005',
    Canceled = '00000051-1000-0000-0000-000000000006',
}
